<template>
  <auth-container>
    <form
      class="max-w-xs bg-white p-6 rounded"
      @submit.prevent="reset">
      <h2 class="text-2xl mb-6">Reset Password</h2>
      <p class="text-red text-xs italic my-4" v-if="error">
        {{error}}
      </p>
      <div class="mb-6">
        <label
          class="block text-sm font-bold pb-2"
          for="password">
          New Password
        </label>
        <input
          class="appearance-none border-gray-light border rounded w-full py-2 px-3 text-sm text-grey-darker leading-tight focus:outline-none focus:shadow-outline tracking-wide"
          id="password"
          type="password"
          name="password"
          v-model="password"
          placeholder="******************">

      </div>
      <div class="flex items-center justify-end">
        <button

          class="bg-full-blue ml-4 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline text-sm"
          type="submit"
        >
          Reset
        </button>

      </div>
    </form>
  </auth-container>
</template>


<script>
 import {mapState, mapGetters} from 'vuex';
 import AuthContainer from '@/components/AuthContainer';
 import api from '@/api';

 export default {
   data() {
     return {
       password: ''
     }
   },
   components: {AuthContainer},
   computed: Object.assign(
     mapState({
       error: state => state.resetPwError
     }),
     mapGetters(['isLoggedIn'])
   ),

   /* created () {
    *   if (this.isLoggedIn) {
    *     this.$router.replace(this.$route.query.redirectFrom || '/');
    *   } else {
    *   }
    * }, */

   async created () {
     this.$store.commit('clearErrors');
     if (this.isLoggedIn) {
       this.$router.replace(this.$route.query.redirectFrom || '/');
     } else {
       const {res, err} = await api.getMemberByToken(this.$route.params.token);
       if (err) {
         // This is here to bring the user to the login if the token is invalid
         this.$router.replace({name: 'login'})
       }
     }
   },

   methods: {
     async reset () {
       const res = await this.$store.dispatch('resetPw', {
         pw: this.password,
         token: this.$route.params.token
       });

       if (res !== false) {
         this.$router.replace({name: 'login', query: {
           last: 'reset'
         }});
       }
     }
   }
 }
</script>
